// Privacy & security verification flags.
//
// Each flag controls ONLY where an item appears on the Privacy & security page:
//   false -> the item stays under "What we are still confirming"
//   true  -> the item moves up into "What we can confirm today"
//
// Flip a flag to true ONLY after Emergent Support has confirmed it in writing, and ALWAYS with
// founder review before deploy. There is no UI for these flags by design.
//
// Compliance-sensitive items (SOC 2 / ISO / GDPR / DPA / sub-processors) must stay conservative.
// In particular, flipping `soc2_type1_confirmed` to true ALSO requires updating the
// "What we do not currently claim" paragraph in TrustPrivacyContent.jsx under founder review —
// it is intentionally NOT rewritten automatically.
export const PRIVACY_FLAGS = {
  encryption_at_rest_confirmed: false,
  data_residency_confirmed: false,
  backups_confirmed: false,
  ai_retention_confirmed: false,
  soc2_type1_confirmed: false,
};

// Ordered list of confirmable facts. Order matches the current "still confirming" list so that,
// while every flag is false, the visible copy is unchanged. `confirmed` copy is shown only once a
// flag is true (kept conservative; wording needs founder review before deploy).
export const CONFIRMABLE_FACTS = [
  {
    flag: "data_residency_confirmed",
    pending: "The exact data residency and hosting region.",
    confirmed: "Your data is hosted in a confirmed region.",
  },
  {
    flag: "encryption_at_rest_confirmed",
    pending: "Encryption at rest.",
    confirmed: "Data is encrypted at rest.",
  },
  {
    flag: "backups_confirmed",
    pending: "Platform-managed backups, retention and deleted-data handling.",
    confirmed: "Backups are enabled, with a defined retention period.",
  },
  {
    flag: "ai_retention_confirmed",
    pending: "AI provider retention and training terms.",
    confirmed: "AI-provider retention and training terms are confirmed.",
  },
  {
    flag: "soc2_type1_confirmed",
    pending: "Formal compliance certifications.",
    confirmed: "Heldall holds SOC 2 Type I.",
  },
];
